import {DEVICE_VERSION_GRAPH, DEVICE_DATE_GRAPH,DASHBOARD_TOTAL_DEVICES} from 'DashboardDeviceAction';

export const DeviceDateGraphReducer = (state = [], action) => {
  if (action.type === DEVICE_DATE_GRAPH) {
    return action.payload;
  }
  return state;
}


export const DeviceVersionGraphReducer = (state = [], action) => {
  if (action.type === DEVICE_VERSION_GRAPH) {
    return action.payload;
  }
  return state;
}

export var DashboardTotalDevices = (state = {}, action) => {
  if (action.type === DASHBOARD_TOTAL_DEVICES) {
    return action.payload;
  }
  return state;
}
